import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CancelUploadTransferJobMutationVariables = Types.Exact<{
  jobId: Types.Scalars['ID']['input'];
}>;


export type CancelUploadTransferJobMutation = { __typename?: 'Mutation', cancelUploadTransferJob: boolean };


export const CancelUploadTransferJob = /*#__PURE__*/ gql`
    mutation CancelUploadTransferJob($jobId: ID!) {
  cancelUploadTransferJob(jobId: $jobId)
}
    ` as unknown as DocumentNode<CancelUploadTransferJobMutation, CancelUploadTransferJobMutationVariables>;

          

          export const useCancelUploadTransferJobMutation = (options?:MutationHookOptions<CancelUploadTransferJobMutation, CancelUploadTransferJobMutationVariables>) => useMutation(CancelUploadTransferJob, options);
          

          export type CancelUploadTransferJobMutationOptions = MutationHookOptions<CancelUploadTransferJobMutation, CancelUploadTransferJobMutationVariables>;

          

          export type CancelUploadTransferJobMutationResult = ReturnType<typeof useCancelUploadTransferJobMutation>[1];

          
